var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.upgradePlanVisible,
        "show-close": false,
        "close-on-click-modal": false,
        "close-on-press-escape": false
      },
      on: {
        "update:visible": function($event) {
          _vm.upgradePlanVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "upgrade-plan-dialog-border" }, [
        _c("div", { staticClass: "upgrade-plan-title" }, [
          _vm._v("Upgrade Your Plan")
        ]),
        _vm._v(" "),
        _vm.active === 1
          ? _c("div", { staticClass: "upgrade-plan-subtitle" }, [
              _vm._v("Get access to:")
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.active === 1
          ? _c(
              "div",
              { staticClass: "upgrade-plan-list" },
              _vm._l(_vm.upgradePlanList, function(item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "upgrade-plan-row" },
                  [
                    _c("div", { staticClass: "upgrade-plan-left" }, [
                      _c("img", { attrs: { src: item.upgradePlanImg } })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "upgrade-plan-right" },
                      [
                        _c("div", { staticClass: "upgrade-plan-right-title" }, [
                          _vm._v(_vm._s(item.upgradePlanTitle))
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "upgrade-plan-right-content" },
                          [_vm._v(_vm._s(item.upgradePlancontent))]
                        ),
                        _vm._v(" "),
                        _c("el-divider")
                      ],
                      1
                    )
                  ]
                )
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.active === 2
          ? _c(
              "div",
              { staticClass: "upgrade-plan-features" },
              [
                _c("div", { staticClass: "upgrade-plan-features-user" }, [
                  _vm._v("Hey " + _vm._s(_vm.userName) + ".")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "upgrade-plan-features-tips" }, [
                  _vm._v("For more features please upgrade your plan")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "upgrade-plan-features-tips" }, [
                  _vm._v("What would you like to talk about?")
                ]),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading"
                      }
                    ],
                    ref: "upgradePlanForm",
                    attrs: { model: _vm.upgradePlanForm, rules: _vm.rules }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "talkAbout" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "What would you like to talk about?"
                            },
                            model: {
                              value: _vm.upgradePlanForm.talkAbout,
                              callback: function($$v) {
                                _vm.$set(_vm.upgradePlanForm, "talkAbout", $$v)
                              },
                              expression: "upgradePlanForm.talkAbout"
                            }
                          },
                          _vm._l(_vm.talkAboutList, function(item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.active === 1
          ? _c("div", { staticClass: "upgrade-plan-action" }, [
              _c(
                "div",
                {
                  staticClass: "upgrade-plan-consult",
                  on: { click: _vm.next }
                },
                [_vm._v("Consult with Sales")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "upgrade-plan-close",
                  on: { click: _vm.closeUpgradePlanDialog }
                },
                [_vm._v("Close")]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.active === 2
          ? _c("div", { staticClass: "upgrade-plan-action" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading"
                    }
                  ],
                  staticClass: "upgrade-plan-consult",
                  on: { click: _vm.confirmUpgradePlan }
                },
                [_vm._v("Done")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading"
                    }
                  ],
                  staticClass: "upgrade-plan-close",
                  on: { click: _vm.closeUpgradePlanDialog }
                },
                [_vm._v("Maybe Later")]
              )
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-409a15d3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-409a15d3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/vilocal/ai-recommendations/ai-recommendations-upgrade-plan.vue
// module id = JRH3
// module chunks = 2